<template>
  <div class="AccordionContentComponent">
    <component
      :is="accordion.component"
      :items="accordion.items"
      :productCode="productCode"
      :businessLine="businessLine"
    />
  </div>
</template>

<script setup lang="ts">
interface PropsInterface {
  accordion: any
  productCode?: string // for documentsComponent
  businessLine?: string | null // for documentsComponent
}
withDefaults(defineProps<PropsInterface>(), {})
</script>